import React from 'react';
import styled from 'styled-components';
import { Patient } from '../types';
import { Divider } from 'antd';

interface PatientItemProps {
    patient: Patient;
    selected?: boolean;
    onClick?: () => void;
}

const Card = styled.div<{ selected?: boolean }>`
    background: ${({ selected }) => selected ? '#e6f7ff' : 'white'};
    border: 1px solid ${({ selected }) => selected ? '#1890ff' : '#e8e8e8'};
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
        border-color: #1890ff;
    }
`;

const Info = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const Name = styled.div`
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
`;

const SubInfo = styled.div`
    color: #666;
    font-size: 12px;
`;

const PatientItem: React.FC<PatientItemProps> = ({
    patient,
    selected,
    onClick
}) => {
    return (
        <Card selected={selected} onClick={onClick}>
            <Info>
                <Name>{patient.name}</Name>
                <SubInfo>
                    {patient.gender === 'man' ? '男' : '女'}   <Divider type="vertical" /> {patient.age}岁 {patient.height && <> <Divider type="vertical" /> {patient.height}厘米</>} {patient.weight && <> <Divider type="vertical" /> {patient.weight}kg</>}
                </SubInfo>
            </Info>
        </Card>
    );
};

export default PatientItem; 